import { useDispatch, useSelector } from "react-redux";
import { addUpcomingMovies } from "../store/slices/moviesSlice";
import { useEffect, useCallback } from "react";
import { API_OPTIONS } from "../utils/constants";
import { RootState } from "../store";

const useUpcomingMovies = () => {
  const dispatch = useDispatch();
  const upcomingMovies = useSelector((store: RootState) => store.movies.upcomingMovies);

  const getUpcomingMovies = useCallback(async () => {
    try {
      const data = await fetch(
        "https://api.themoviedb.org/3/movie/upcoming?page=1",
        API_OPTIONS
      );
      const json = await data.json();
      dispatch(addUpcomingMovies(json.results));
    } catch (error) {
      console.error("Error fetching upcoming movies:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    if (!upcomingMovies) getUpcomingMovies();
  }, [upcomingMovies, getUpcomingMovies]);
};

export default useUpcomingMovies;
